import React, { Component, useState } from "react";

import axios from '@app/lib/axios';
import { Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import { InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import moment from "moment";

import "@app/css/datepicker_common.css";
import { toast } from "react-toastify";

class DeviceSearchConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: null,
            selectedBranchId: -1,
            selectedNurseryId: -1,
            searchSelectType: "user",
            searchKeyword: "",
            textPlaceHolder: "검색할 기기의 계정을 입력해주세요.",
            optBranches: [],
            optNurseries: [],
        };
    }
    componentDidMount() {}
    componentWillReceiveProps = (nextProps) => {
        if (nextProps.branchId > 0) {
            this.setState({ selectedBranchId: nextProps.branchId });
        }
        if (nextProps.branches != null) {
            this.setState({ optBranches: this.setOptionBranches(nextProps.branches) });
        }
        if (nextProps.nurseries != null) {
            this.setState({ optNurseries: this.setOptionNurseries(nextProps.nurseries) });
        }
    };

    setOptionBranches = (branches) => {
        var optBranches = [];
        optBranches.push(
            <option key="branch-all" value="-1">
                지사를 선택해주세요.
            </option>
        );

        if (branches == null) {
            return optBranches;
        }
        for (var i = 0; i < branches.length; i++) {
            var branch = branches[i];
            optBranches.push(
                <option key={"branch-" + branch.id} value={branch.id}>
                    {branch.name}
                </option>
            );
        }

        return optBranches;
    };

    setOptionNurseries = (nurseries) => {
        var optNurseries = [];

        if (nurseries == null || this.state.selectedBranchId == -1) {
            optNurseries.push(
                <option key="nursery-all" value="-1">
                    {" "}
                    -{" "}
                </option>
            );
            return optNurseries;
        }

        optNurseries.push(
            <option key="nursery-all" value="-1">
                전체
            </option>
        );
        for (var i = 0; i < nurseries.length; i++) {
            var nursery = nurseries[i];
            if (this.props.branchId > 0 || nursery.branch_id == this.state.selectedBranchId) {
                optNurseries.push(
                    <option key={"nursery-" + nursery.id} value={nursery.id}>
                        {nursery.name}
                    </option>
                );
            }
        }

        return optNurseries;
    };

    onBranchChange = (e) => {
        var value = e.target.value;
        this.setState({ searchKeyword: "" }, () => {
            this.changeBranch(value);
        });
    };
    changeBranch = (branchId) => {
        this.setState({ selectedBranchId: branchId }, () => {
            this.setState({ selectedNurseryId: -1, optNurseries: this.setOptionNurseries(this.props.nurseries) }, () => {
                this.props.onSearchConfigChangedHandler("branch", this.state.selectedBranchId);
            });
        });
    };

    onNurseryChange = (e) => {
        var value = e.target.value;
        this.setState({ searchKeyword: "" }, () => {
            this.changeNursery(value);
        });
    };
    changeNursery = (nurseryId) => {
        this.setState({ selectedNurseryId: nurseryId }, () => {
            this.props.onSearchConfigChangedHandler("nursery", this.state.selectedNurseryId);
        });
    };

    onSearchTypeChange = (e) => {
        var textPlaceHolder = "검색할 기기의 계정을 입력해주세요.";
        if (e.target.value == "did") {
            textPlaceHolder = "검색할 기기 ID(DID)를 입력해주세요.";
        } else if (e.target.value == "nurseryName") {
            textPlaceHolder = "검색할 기기의 원 이름을 입력해주세요.";
        } else if (e.target.value == "branchName") {
            textPlaceHolder = "검색할 기기의 지사 이름을 입력해주세요.";
        }
        this.setState({ searchSelectType: e.target.value, textPlaceHolder: textPlaceHolder });
    };

    onSearchKeywardChange = (e) => {
        this.setState({ searchKeyword: e.target.value });
    };    
    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (this.state.searchKeyword != "") {
                this.onSearch(e);
            } else {
                toast.error('검색어를 입력해 주세요.');
            }
        }
    };
    onSearch = (e) => {
        if (this.state.searchKeyword != "") {
            this.props.onSearchConfigChangedHandler(this.state.searchSelectType, this.state.searchKeyword);
        }
    };

    render() {
        const { branchId } = this.props;
        return (
            <div className="card border-top border-3 border-top-info">
                <div className="card-body" style={{}}>
                    <div className="row">
                        {/* <div className="col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12">
                            <InputGroup className="">
                                <InputGroup.Prepend>
                                    <InputGroup.Text style={{ width: "50px", justifyContent: "center" }}>앱</InputGroup.Text>
                                </InputGroup.Prepend>
                                <select className="form-control input-group-append" title="기기를 검색할 앱을 선택해 주세요." value={this.state.searchSelectApp} onChange={(e) => this.setState({searchSelectApp: e.target.value})} style={{ height: "auto" }}>
                                    <option value="tomonote" defaultChecked>토모노트</option>
                                    <option value="books">토모동화</option>
                                    <option value="tas">TAS</option>
                                    <option value="english">FlyEng</option>
                                </select>
                            </InputGroup>
                        </div> */}
                        {!branchId && (
                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                                <InputGroup className="">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text style={{ width: "50px", justifyContent: "center" }}>지 사</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <select className="form-control input-group-append" defaultValue={-1} onChange={(e) => this.onBranchChange(e)} style={{ height: "auto" }}>
                                        {this.state.optBranches}
                                    </select>
                                </InputGroup>
                            </div>
                        )}
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                            <InputGroup className="">
                                <InputGroup.Prepend>
                                    <InputGroup.Text style={{ width: "50px", justifyContent: "center" }}>원</InputGroup.Text>
                                </InputGroup.Prepend>
                                <select className="form-control input-group-append" value={this.state.selectedNurseryId} onChange={(e) => this.onNurseryChange(e)} style={{ height: "auto" }}>
                                    {this.state.optNurseries}
                                </select>
                            </InputGroup>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <InputGroup className="input-group my-group">
                                <InputGroup.Prepend>
                                    <InputGroup.Text style={{ width: "50px", justifyContent: "center" }}>검색</InputGroup.Text>
                                </InputGroup.Prepend>
                                <select
                                    className="form-control input-group-append"
                                    title="검색 항목 선택"
                                    value={this.state.searchSelectType}
                                    onChange={(e) => this.onSearchTypeChange(e)}
                                    style={{ height: "auto", maxWidth: "100px" }}
                                >
                                    <option value="user" defaultChecked>
                                        계정
                                    </option>
                                    <option value="did">DID</option>
                                    {/* <option value="branchName">지사</option> */}
                                    <option value="nurseryName">원</option>
                                </select>
                                <input className="form-control" type="text" value={this.state.searchKeyword} placeholder={this.state.textPlaceHolder} onChange={this.onSearchKeywardChange} onKeyPress={this.handleKeyPress} />
                                <InputGroup.Append>
                                    <Button className="btn btn-primary" onClick={(e) => this.onSearch(e)}>
                                        검색
                                    </Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeviceSearchConfig;
